import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

export default function PdfPortal({ children }) {
  const [container] = useState(() => {
    const el = document.createElement("div");
    el.id = "pdf-hidden-root";
    el.style.position = "absolute";
    el.style.left = "-9999px";
    el.style.top = "0";
    el.style.width = "1000px";
    el.style.opacity = "0";
    el.style.pointerEvents = "none";
    return el;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => document.body.removeChild(container);
  }, [container]);

  return createPortal(children, container);
}
